import _ from "lodash";

const iconProps = (width, height) => ({
  width,
  height,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
});

const DropIcon2 = ({ width = "6.5rem", height = "6.5rem" }) => (
  <svg {...iconProps(width, height)}>
    <path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />
    <path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />
    <path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" />
  </svg>
);

const AirIcon2 = ({ width = "6.5rem", height = "6.5rem" }) => (
  <svg {...iconProps(width, height)}>
    <path d="M12.8 19.6A2 2 0 1 0 14 16H2" />
    <path d="M17.5 8a2.5 2.5 0 1 1 2 4H2" />
    <path d="M9.8 4.4A2 2 0 1 1 11 8H2" />
  </svg>
);

const ThunderIcon2 = ({ width = "6.5rem", height = "6.5rem" }) => (
  <svg {...iconProps(width, height)}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const DefaultIcon2 = ({ width = "6.5rem", height = "6.5rem" }) => (
  <svg {...iconProps(width, height)}>
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </svg>
);

export const NodeCardV2Avatar = ({ nodeType }) => {
  let avatarIcon = "";
  if (
    _.includes(
      [
        "FLOWMETER",
        "PHMETER",
        "WATER_QUALITY_ANALYZER",
        "TANK_LEVEL",
        "TDS_METER",
      ],
      _.toUpper(nodeType)
    )
  ) {
    avatarIcon = <DropIcon2 height={"5.5rem"} width={"5.5rem"} />;
  } else if (
    _.includes(
      [
        "AIR QUALITY SENSOR",
        "GAS_ANALYZER",
        "CO2_METER",
        "TANK_LEVEL",
        "VAPOUR COLUMN",
      ],
      _.toUpper(nodeType)
    )
  ) {
    avatarIcon = <AirIcon2 height={"5.5rem"} width={"5.5rem"} />;
  } else if (
    _.includes(
      [
        "POWERMETER",
        "POWER_FACTOR",
        "APPARENT_POWER",
        "VOLTAGE_P-P",
        "VOLTAGE_PHASE",
        "CURRENT",
        "POWER",
        "ENERGY_METER",
      ],
      _.toUpper(nodeType)
    )
  ) {
    avatarIcon = <ThunderIcon2 height={"5.5rem"} width={"5.5rem"} />;
  } else {
    avatarIcon = <DefaultIcon2 height={"5.5rem"} width={"5.5rem"} />;
  }
  return avatarIcon;
};
